import { Dialog, Transition } from '@headlessui/react';
import { X } from 'lucide-react';
import { Fragment } from 'react';

function DeleteStudentDialog({
  isOpen,
  onClose,
  studentName,
  onDelete,
  title
}: {
  isOpen: boolean;
  onClose: () => void;
  studentName: string;
  onDelete: () => void;
  title: string;
}) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as='div' className='relative z-50' onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-200'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-150'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-black/40' />
        </Transition.Child>

        <div className='fixed inset-0 overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center p-4 text-center'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-200'
              enterFrom='opacity-0 scale-95'
              enterTo='opacity-100 scale-100'
              leave='ease-in duration-150'
              leaveFrom='opacity-100 scale-100'
              leaveTo='opacity-0 scale-95'
            >
              <Dialog.Panel className='w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all'>
                <div className='mb-4 flex items-center justify-between'>
                  <Dialog.Title className='text-xl font-semibold text-gray-900'>
                    {title}
                  </Dialog.Title>
                  <button
                    type='button'
                    className='rounded-lg p-2 hover:bg-gray-100'
                    onClick={onClose}
                  >
                    <X className='h-5 w-5 text-gray-600' />
                  </button>
                </div>

                <p className='mb-6 text-gray-700'>
                  Are you sure you want to delete
                  <span className='font-semibold text-red-600'>
                    {' '}
                    {studentName}{' '}
                  </span>
                  ? This action cannot be undone.
                </p>

                <div className='mt-4 flex justify-end gap-3'>
                  <button
                    className='rounded-xl border border-gray-300 px-4 py-2 transition hover:bg-gray-100'
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                  <button
                    className='rounded-xl bg-red-600 px-4 py-2 text-white transition hover:bg-red-700'
                    onClick={onDelete}
                  >
                    Delete
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default DeleteStudentDialog;
